var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22222 4H8.66667L12 7.2H19.7778C20.3671 7.2 20.9324 7.42476 21.3491 7.82484C21.7659 8.22492 22 8.76754 22 9.33333V17.8667C22 18.4325 21.7659 18.9751 21.3491 19.3752C20.9324 19.7752 20.3671 20 19.7778 20H4.22222C3.63285 20 3.06762 19.7752 2.65087 19.3752C2.23413 18.9751 2 18.4325 2 17.8667V6.13333C2 5.56754 2.23413 5.02492 2.65087 4.62484C3.06762 4.22476 3.63285 4 4.22222 4Z",
    fill: "#18818B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5L11.5 16.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.5L14.5 13.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFolder);
export default __webpack_public_path__ + "static/media/createFolder.643caf2a.svg";
export { ForwardRef as ReactComponent };